import { render, staticRenderFns } from "./DatasetPropertiesInformationQuickLook.vue?vue&type=template&id=e7ef7e28&scoped=true&"
import script from "./DatasetPropertiesInformationQuickLook.vue?vue&type=script&lang=js&"
export * from "./DatasetPropertiesInformationQuickLook.vue?vue&type=script&lang=js&"
import style0 from "./DatasetPropertiesInformationQuickLook.vue?vue&type=style&index=0&id=e7ef7e28&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7ef7e28",
  null
  
)

export default component.exports